export const POST = 'dhsv_theme/routes/POST'
export const FRONTPAGE = 'dhsv_theme/routes/FRONTPAGE'
